import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GeneralTask from './generalTask';
import { usePage } from '../../context/PageContext';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { TaskSections } from '../../constants/tasks';
import { ROUTES } from '../../constants/constants';
import { useNavigationStack } from '../../context/NavigationStackContext';
import CustomTabs from '../customTabs/customTabs';
import CriticalTaskLayout from '../criticalTask/criticalTaskLayout';

const TaskLayout = () => {
  const { t } = useTranslation();
  const { setTitle } = usePage();
  const location = useLocation();
  const { clear, push, updateTop } = useNavigationStack();
  const fromTab = location?.state?.fromTab ?? TaskSections.criticalTasks;
  const [selectedTab, setSelectedTab] = useState<string>(String(fromTab));
  const items = useMemo(
    () => [
      {
        key: String(TaskSections.criticalTasks),
        label: t('common:tab.criticalTasks'),
        children: (
          <div className="h-full">
            <CriticalTaskLayout data-testid="task-detail-critical-task" />
          </div>
        ),
      },
      {
        key: String(TaskSections.generalTasks),
        label: t('common:tab.tasks'),
        children: (
          <div className="h-full">
            <GeneralTask data-testid="task-detail-general-task" />
          </div>
        ),
      },
    ],
    [],
  );
  useEffect(() => {
    updateTop({ fromTab: selectedTab });
  }, [selectedTab]);
  const handleHome = () => {
    clear();
    push(ROUTES.DASHBOARD);
  };

  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        title={t('task:tasks')}
        showMenu
        showSettings
        handleHome={handleHome}
      />,
    );
  }, []);
  return (
    <div className="dashboard-wrapper">
      <CustomTabs
        data-testid="task-detail-tabs"
        items={items}
        activeKey={selectedTab}
        onChange={setSelectedTab}
      />
    </div>
  );
};

export default TaskLayout;
